import { __awaiter } from "tslib";
import { computed, ref } from 'vue';
import ApiManager from '@/managers/apimanagers';
import { useStore } from '@/store/store';
/**
 * @summary 通知メッセージ
 */
export const useNotification = () => {
    const isLoading = ref(false);
    const store = useStore();
    const unreadCount = computed(() => store.state.unreadNotificationCount);
    const getUnreadCount = () => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield ApiManager.get(`/notifications/count/unread`);
        store.state.unreadNotificationCount = res.count;
        return res;
    });
    const getNotifications = (cursor) => __awaiter(void 0, void 0, void 0, function* () {
        return yield ApiManager.get(`/notifications`, !!cursor && { cursor });
    });
    const readNotification = (id) => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield ApiManager.patch(`/notification/${id}/read`, {});
        store.state.unreadNotificationCount = res.unread_count;
        return res;
    });
    const readAllNotification = () => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield ApiManager.patch(`/notifications/read-all`, {});
        store.state.unreadNotificationCount = res.unread_count;
        return res;
    });
    const deleteNotification = (id) => __awaiter(void 0, void 0, void 0, function* () {
        yield ApiManager.delete(`/notification/${id}/delete`);
    });
    return {
        isLoading,
        unreadCount,
        getUnreadCount,
        getNotifications,
        readNotification,
        readAllNotification,
        deleteNotification,
    };
};
